'use client';

import { c as _c } from "react/compiler-runtime";
import type { AdpopcornPlacementKey } from '@/constants/adpopcorn';
import { ADPOPCORN_PLACEMENT_IDS } from '@/constants/adpopcorn';
import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useAdGuards } from './useAdGuards';
export type AdpopcornStatus = 'unsupported' | 'app-install' | 'login' | 'ready';
interface UseAdpopcornOptions {
  placement: AdpopcornPlacementKey;
}
interface UseAdpopcornPlacementReturn {
  status: AdpopcornStatus;
  placementId: string | null;
  isExternalWebview: boolean;
}
interface UseAdpopcornReturn {
  status: AdpopcornStatus;
  placementId: string | null;
  isExternalWebview: boolean;
  onClick: () => void;
  isOpening: boolean;
}
export const useAdpopcornPlacement = t0 => {
  const $ = _c(4);
  const {
    placement
  } = t0;
  const {
    isMounted,
    isWelloApp,
    isExternalWebview,
    osType
  } = useAdGuards();
  const memberOAuth = useAuthStore(_temp);
  const placementConfig = ADPOPCORN_PLACEMENT_IDS[placement];
  const placementId = osType === "ios" || osType === "android" ? placementConfig[osType] : null;
  let t1;
  bb0: {
    if (!isMounted || isExternalWebview) {
      t1 = "unsupported";
      break bb0;
    }
    if (!isWelloApp) {
      t1 = "app-install";
      break bb0;
    }
    if (!memberOAuth) {
      t1 = "login";
      break bb0;
    }
    if (!placementId) {
      t1 = "unsupported";
      break bb0;
    }
    t1 = "ready";
  }
  const status = t1;
  let t2;
  if ($[0] !== isExternalWebview || $[1] !== placementId || $[2] !== status) {
    t2 = {
      status,
      placementId,
      isExternalWebview
    };
    $[0] = isExternalWebview;
    $[1] = placementId;
    $[2] = status;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const useAdpopcorn = t0 => {
  const $ = _c(16);
  const {
    placement
  } = t0;
  let t1;
  if ($[0] !== placement) {
    t1 = {
      placement
    };
    $[0] = placement;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    status,
    placementId,
    isExternalWebview
  } = useAdpopcornPlacement(t1);
  const memberOAuth = useAuthStore(_temp2);
  const setIsShowAppInstallConfirmModal = useGlobalStore(_temp3);
  const setIsShowLoginRedirectionConfirmModal = useGlobalStore(_temp4);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: MESSAGE_KEYWORD.OPEN_ADPOPCORN_BRIDGE
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    request,
    isPending
  } = useHandleApp(t2);
  let t3;
  if ($[3] !== memberOAuth || $[4] !== placementId || $[5] !== request || $[6] !== setIsShowAppInstallConfirmModal || $[7] !== setIsShowLoginRedirectionConfirmModal || $[8] !== status) {
    t3 = () => {
      if (status === "app-install") {
        setIsShowAppInstallConfirmModal(true);
        return;
      }
      if (status === "login") {
        setIsShowLoginRedirectionConfirmModal(true);
        return;
      }
      if (status === "ready") {
        if (!memberOAuth) {
          return;
        }
        request({
          placementId,
          userId: String(memberOAuth)
        });
      }
    };
    $[3] = memberOAuth;
    $[4] = placementId;
    $[5] = request;
    $[6] = setIsShowAppInstallConfirmModal;
    $[7] = setIsShowLoginRedirectionConfirmModal;
    $[8] = status;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onClick = t3;
  let t4;
  if ($[10] !== isExternalWebview || $[11] !== isPending || $[12] !== onClick || $[13] !== placementId || $[14] !== status) {
    t4 = {
      status,
      placementId,
      isExternalWebview,
      onClick,
      isOpening: isPending
    };
    $[10] = isExternalWebview;
    $[11] = isPending;
    $[12] = onClick;
    $[13] = placementId;
    $[14] = status;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
function _temp(state) {
  return state.myInfo?.memberOAuth;
}
function _temp2(state) {
  return state.myInfo?.memberOAuth;
}
function _temp3(state_0) {
  return state_0.setIsShowAppInstallConfirmModal;
}
function _temp4(state_1) {
  return state_1.setIsShowLoginRedirectionConfirmModal;
}